<div class="page-content-block">

    <h2>Для начала работы с приложением</h2>
    Воспользуйтесь ботом в telegram: <a href="https://t.me/RpaBrnBot">RpaBrnBot</a>
</div>

<div class="page-content-block" *ngIf="connMgr.users.length">
    <h1>Настройка пользователя</h1>
    <div class="settings-area">
        <mat-form-field appearance="outline" style="width: calc(100% - 55px); margin-right: 4px;">
            <mat-label>Пользователь</mat-label>
            <mat-select [(ngModel)]="activeUserId" (ngModelChange)="changeActiveUser()">
                <mat-option *ngFor="let user of connMgr.users" [value]="user.id">
                    ({{ user.user.Server }}) {{user.user.Phone}} {{user.user.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button style="vertical-align: middle;" mat-icon-button color="warn"
            (click)="deleteUser()"><mat-icon>delete</mat-icon></button>
    </div>
    <div>
        <h2>Привязанные агенты</h2>
        <mat-list *ngIf="connMgr.Connections?.length">
            <ng-container *ngFor="let serv of connMgr.Connections">
                <mat-list-item>
                    <div class="text_wrap" [style]="activeServ(serv) ? 'font-weight:bold':''" matListItemLine
                        matListItemTitle="1" style="padding-right: 8px;">
                        <div matBadge="!" [matBadgeHidden]="!checkTimeConn(serv)" matBadgeSize="small"
                            matBadgeColor="accent">
                            {{serv.title}} ({{serv?.agent?.Code}})
                        </div>

                    </div>
                    <div *ngIf="media.isMobile" matListItemMeta>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon color="primary">more_vert</mat-icon></button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="deleteServ(serv)" style="vertical-align: middle;">
                                <mat-icon color="warn">delete</mat-icon>
                                <span>Удалить</span>
                            </button>

                        </mat-menu>

                    </div>
                    <div *ngIf="!media.isMobile" matListItemMeta>
                        <button mat-icon-button (click)="deleteServ(serv)" style="vertical-align: middle;">
                            <mat-icon color="warn">delete</mat-icon></button>
                    </div>

                </mat-list-item>
            </ng-container>
        </mat-list>

        <br>

        <mat-form-field style="width: calc(100% - 55px); margin-right: 4px;" appearance="outline">
            <mat-label>Доступные агенты</mat-label>
            <input type="text" matInput [formControl]="profile" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of profiles$ | async" [value]="option" [disabled]="option.exists">
                    {{option.name}}
                </mat-option>
            </mat-autocomplete>
            <button *ngIf="this.profile.value" mat-icon-button matSuffix (click)="this.profile.setValue(undefined)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <button mat-icon-button class="mat-raised-button-custom" color="primary" [disabled]="!profile || !profile.value"
            (click)="addConn(profile.value)" style="vertical-align: middle;"><mat-icon>person_add</mat-icon></button>

    </div>




</div>



<div class="page-content-block" *ngIf="isAdmin()">
    <h2>Для администратора</h2>
    <mat-form-field class="w50" appearance="outline">
        <mat-label>готовый токен</mat-label>
        <input matInput [(ngModel)]="externalToken">
    </mat-form-field>
    <br>

    <button mat-raised-button color="primary" [disabled]="!externalToken" (click)="applyExternalToken() ">Добавить
        токен</button>
</div>

<div class="page-content-block">
    <h2>Вставьте ссылку, полученную из бота</h2>
    <mat-form-field class="w50" appearance="outline">
        <mat-label>Ссылка</mat-label>
        <input matInput [(ngModel)]="appleInput">
    </mat-form-field>
    <br>

    <button mat-raised-button color="primary" [disabled]="!appleInput" (click)="appleReg()">Добавить</button>
</div>